/* Native Judge.me presentation enhancer.
   It runs a small, bounded number of times to accommodate the app's async render.
   There are no MutationObservers, intervals, or continuous DOM scans. */
(function () {
  'use strict';

  function removeDuplicateWidget() {
    document.querySelectorAll('.tg-pdp-dr__reviews-wrap, .tangible-pdp-section--reviews').forEach(function (node) {
      node.remove();
    });
  }

  function makeElement(tag, className, text) {
    var element = document.createElement(tag);
    element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function enhanceWidget(widget) {
    if (!widget || widget.closest('.tg-pdp-dr__reviews-wrap, .tangible-pdp-section--reviews')) return;

    var action = widget.querySelector('.jdgm-widget-actions-wrapper');
    var writeLink = widget.querySelector('.jdgm-write-rev-link');
    if (!action || !writeLink) return;

    action.classList.add('tg-jdgm-action-card');

    var icon = action.querySelector('.tg-jdgm-action-icon');
    if (!icon) {
      icon = makeElement('span', 'tg-jdgm-action-icon');
      icon.setAttribute('aria-hidden', 'true');
      action.insertBefore(icon, action.firstChild);
    }

    var title = action.querySelector('.tg-jdgm-action-title');
    if (!title) {
      title = makeElement('div', 'tg-jdgm-action-title');
      action.insertBefore(title, writeLink);
    }

    var hasReviews = Boolean(widget.querySelector('.jdgm-rev'));
    title.textContent = hasReviews
      ? 'Worn it? Share your experience.'
      : 'Be the first to write a review';

    var divider = action.querySelector('.tg-jdgm-empty-divider');
    var emptyCopy = action.querySelector('.tg-jdgm-empty-copy');

    if (!hasReviews) {
      if (!divider) {
        divider = makeElement('div', 'tg-jdgm-empty-divider', 'OR');
        action.appendChild(divider);
      }
      if (!emptyCopy) {
        emptyCopy = makeElement('div', 'tg-jdgm-empty-copy', 'No reviews yet for this product.');
        action.appendChild(emptyCopy);
      }
    } else {
      if (divider) divider.remove();
      if (emptyCopy) emptyCopy.remove();
    }

    var footer = widget.querySelector('.jdgm-rev-widg__footer');
    if (footer && footer.parentNode !== action) {
      action.appendChild(footer);
    }
  }

  function run() {
    removeDuplicateWidget();
    document.querySelectorAll('.jdgm-review-widget').forEach(enhanceWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('load', run, { once: true });
  [250, 750, 1500, 3000].forEach(function (delay) {
    window.setTimeout(run, delay);
  });
})();
